/* eslint-disable react/jsx-props-no-spreading */
import { FC, ComponentProps, useState } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectors } from '@altermaind/core/i18n';
import { Box, Datepicker } from '@altermaind/web/ui';
import { DEFAULT_LANGUAGE } from '@/_shared/constants';
import { getLocaleAndFormatDateFromTimeZone } from '@/_shared/helpers/getLocaleAndFormatDateFromTimeZone';
import { StyledDatePickerWrapper } from './styles';

type DateRangeType = {
  start: { day: string; isoDate: string };
  end: { day: string; isoDate: string };
};

type Props = {
  control: Control<FieldValues>;
  name: string;
  containerProps?: ComponentProps<typeof Box>;
  additonalProps?: Record<string, unknown>;
  defaultValue?: string;
  ['data-testid']?: string;
} & ComponentProps<typeof Datepicker>;

export const WrappedDatePicker: FC<Props> = ({
  control,
  name,
  additonalProps,
  containerProps,
  ...props
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [date, setDate] = useState<string | DateRangeType>('');
  const language = useSelector(selectors.selectCurrentLanguage) || DEFAULT_LANGUAGE;
  const { locale } = getLocaleAndFormatDateFromTimeZone();

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledDatePickerWrapper {...containerProps} data-testid={props?.['data-testid']}>
      <Controller
        control={control}
        name={name}
        rules={{ ...additonalProps }}
        render={({ field }) => (
          <Datepicker
            onDateChange={selectedDate => {
              setDate(selectedDate);
              field.onChange(selectedDate);
            }}
            defaultDate={field.value}
            {...field}
            {...props}
            lang={language || 'it'}
            dateLocale={locale || 'it-IT'}
          />
        )}
      />
    </StyledDatePickerWrapper>
  );
};
